// Help-citation debug observability — browser side.
//
// Mirrors citationDebug.js (case-doc viewer). Three surfaces:
//   1) console.info("help.<event>", {...}) — readable in DevTools
//   2) window.__helpCitationDebug — last-action state, inspectable
//   3) Backend correlates via X-Operation-Id from /help/conversations/...
//
// runId threads the events emitted by one chat turn together. operationId
// (when present) lets a Cloud Logging query reconstruct the full server-
// side trace for that turn — same operation_id spine as Ask Arc.

let _runId = 0;

function _setState(patch) {
  if (typeof window === 'undefined') return;
  const prev = window.__helpCitationDebug || {};
  window.__helpCitationDebug = { ...prev, ...patch };
}

export function startHelpRun(meta) {
  _runId += 1;
  const state = {
    runId: _runId,
    startedAt: new Date().toISOString(),
    operationId: meta?.operationId || null,
    ...meta,
  };
  _setState(state);
  // eslint-disable-next-line no-console
  console.info('help.chat.turn', { runId: _runId, ...meta });
  return state;
}

export function logHelpCitationsRendered(info) {
  _setState({ rendered: info });
  // eslint-disable-next-line no-console
  console.info('help.citation.render', { runId: _runId, ...info });
}

export function logHelpCitationClick(info) {
  _setState({ lastClick: info });
  // eslint-disable-next-line no-console
  console.info('help.citation.click', { runId: _runId, ...info });
}

export function logHelpArticleOpen(info) {
  _setState({ articleOpen: info });
  // eslint-disable-next-line no-console
  console.info('help.article.open', { runId: _runId, ...info });
}

export function logHelpArticleHighlight(info) {
  _setState({ articleHighlight: info });
  // eslint-disable-next-line no-console
  console.info('help.article.highlight', { runId: _runId, ...info });
}

export function currentHelpRunId() {
  return _runId;
}
